{
	"filter": {
		"plantName": "Plant name",
		"plantId": "Plant ID",
		"country": "Country"
	},
	"clearAllFilters": "Clear all filters"
}
